import { useEffect } from "react"

/**
 * Limpia el indicador de error de un campo cuando su valor pasa la validación.
 * @param {*}        value      - Valor actual del campo.
 * @param {Function} isValid    - Función que recibe el valor y retorna boolean.
 * @param {boolean}  hadError   - Flag que indica si el campo tenía error.
 * @param {Function} setError   - Setter del flag de error (e.g. setProcedimientoHadError).
 * @param {Function} setMessage - Setter del mensaje de error global (setMessageError).
 * @param {Array}    extraDeps  - Dependencias adicionales opcionales del useEffect.
 */
const useFieldValidation = (value, isValid, hadError, setError, setMessage, extraDeps = []) => {
    useEffect(() => {
        if (isValid(value)) {
            if (hadError) setMessage("")
            setError(false)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value, hadError, ...extraDeps])
}

export default useFieldValidation
